
// playground requires you to assign document definition to a variable called dd
export const convertToPDFReport = ({ invoiceData, firm, fromDate, toDate }) => {
    var dd = {
        //pageOrientation: 'landscape',
        content: [
            {
                table: {
                    widths: ['20%', '40%', '20%', '20%'],
                    body: [
                        [

                            { text: '', style: "reportHeader1" },
                            { text: 'FIRM NOT SELECTED\n', style: "reportHeader" },
                            { text: 'From:NOT SELECTED\n', style: "reportHeader" },
                            { text: 'To:  NOT SELECTED\n', style: "reportHeader" },
                        ],

                    ]
                }

            },
            { text: '\n', style: '' },
            {
                table: {
                    widths: ['20%', '20%', '20%', '20%','20%'],
                    body: [
                        [

                            // { text: 'Firm', style: "gstHeader" },
                            { text: 'Date', style: "gstHeader" },
                            { text: 'Customer Name', style: "gstHeader" },
                            { text: 'Payment Number', style: "gstHeader" },
                            { text: 'Amount', style: "gstHeader" },
                            { text: 'Payment type', style: "gstHeader" },

                        ],

                    ]
                }

            },

        ],
        styles: {
            gstHeader: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderBuyer1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderTotal1: {
                fontSize: 6,
                bold: true,
                alignment: 'center',
                color: '#160091'
            },
            gstHeaderBasic1: {
                fontSize: 10,
                bold: true,
                alignment: 'center',
            },
            gstHeaderBuyer: {
                fontSize: 8,
                bold: true,
                alignment: 'left',
                color: '#160091'
            },
            gstHeaderTotal: {
                fontSize: 8,
                bold: true,
                alignment: 'right',
                color: '#160091'
            },
            gstHeaderBasic: {
                fontSize: 10,
                bold: true,
                alignment: 'right',
            },
            gstData: {
                fontSize: 9,
                bold: true,
                alignment: 'center'
            },
            gstHeaderInvoice: {
                fontSize: 7,
                bold: true,
                alignment: 'left'
            },
            reportHeader: {
                fontSize: 12,
                bold: true,
                alignment: 'center'
            },
            reportHeader1: {
                fontSize: 14,
                bold: true,
                alignment: 'left',
                color:"#160091"
            }
        }

    }

        dd.content[0].table.body[0][0].text = "Payment Register"
    if (firm) {
        dd.content[0].table.body[0][1].text = '' + firm + '\n';
    }
    if (fromDate) {
        dd.content[0].table.body[0][2].text = 'From ' + fromDate + '\n';
    }
    if (toDate) {
        dd.content[0].table.body[0][3].text = 'To ' + toDate + '\n';
    }

    invoiceData.map((invoice) => {
            dd.content[2].table.body.push(
                [
  
                    // { text: invoice.firmName, style: "gstData" },
                    { text: new Date(invoice.date).toLocaleDateString("en-IN"), style: "gstData" },
                    { text: invoice.buyerName, style: "gstData" },
                    { text: invoice.receiptNumber, style: "gstData" },
                    { text: Number.parseFloat(invoice.amount).toFixed(2), style: "gstHeaderBasic" },
                    { text: invoice.paymentType, style: "gstData" },
                ]
            )
    })
    return dd;
}


// WEBPACK FOOTER //
// ./src/utils/pdf-reports/payment-register-report.js